import React from 'react';
import { CTAButton } from './CTAButton';
export function PainSection() {
  return <section className="bg-[#0B211A] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-126">
      <div className="max-w-2xl mx-auto" data-id="element-127">
        <h2 className="text-xl md:text-2xl font-black text-white mb-3 text-center leading-tight uppercase" data-id="element-128">
          🚜 SI ENSEÑÁS EN ESCUELA RURAL… ESTO TE PASA.
        </h2>

        <div className="bg-[#102A1F] border border-[#1F3D2B] rounded-xl p-3 md:p-4 shadow-xl" data-id="element-129">
          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-2 leading-snug text-center" data-id="element-130">
            Terminás una clase… y ya tenés que pensar la siguiente. No hay
            pausa. No hay sistema.
          </p>

          <div className="bg-[#071A14] border-l-4 border-[#D4A843] p-2 mb-3" data-id="element-131">
            <p className="text-sm md:text-base font-black text-[#D4A843] text-center" data-id="element-132">
              👉 Siempre estás corriendo atrás del contenido.
            </p>
          </div>

          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-2 leading-snug text-center" data-id="element-133">
            Buscás material de geografía… pero todo es:
          </p>

          <div className="flex justify-center gap-3 mb-3" data-id="element-134">
            <span className="text-[#BFC9C5] font-bold text-xs md:text-sm" data-id="element-135">
              <span className="text-[#8B2E2E]" data-id="element-136">❌</span> Muy teórico
            </span>
            <span className="text-[#BFC9C5] font-bold text-xs md:text-sm" data-id="element-137">
              <span className="text-[#8B2E2E]" data-id="element-138">❌</span> Urbano
            </span>
            <span className="text-[#BFC9C5] font-bold text-xs md:text-sm" data-id="element-139">
              <span className="text-[#8B2E2E]" data-id="element-140">❌</span> Poco aplicable
            </span>
          </div>

          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-3 leading-snug text-center" data-id="element-141">
            Intentás adaptarlo. Intentás hacerlo práctico. Intentás conectar con
            la realidad de tus alumnos… Pero nunca termina de cerrar.
          </p>

          <div className="bg-red-900/20 border-l-4 border-[#8B2E2E] p-2 mb-3" data-id="element-142">
            <p className="text-base md:text-lg font-black text-red-400 text-center" data-id="element-143">
              👉 Terminás improvisando.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3" data-id="element-144">
            {['No tenés material de geografía rural aplicado', 'Todo lo tenés que adaptar vos', 'Perdés horas todas las semanas', 'No sabés cómo llevar la teoría al campo'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#071A14] p-2 rounded-lg border border-[#1F3D2B]" data-id="element-145">
                <span className="text-[#8B2E2E] text-xs flex-shrink-0" data-id="element-146">❌</span>
                <span className="text-[#BFC9C5] font-bold text-xs md:text-sm leading-tight" data-id="element-147">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="bg-[#071A14] rounded-lg p-2 text-center mb-3 border border-[#D4A843]/30" data-id="element-148">
            <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-149">
              👉 Te frustra. 👉 Te agota. 👉 Te hace enseñar por debajo de tu
              nivel.
            </p>
          </div>

          <p className="text-lg md:text-xl font-black text-white text-center mb-4" data-id="element-150">
            ❗ ¿Cuántas clases más vas a seguir así?
          </p>
        </div>
      </div>
    </section>;
}